import React, { useEffect, useState } from 'react';
import styles from './InputField.module.scss';

function InputField({
  refElement,
  label,
  labelStyle = {},
  inputStyle = {},
  type = 'text',
  hasError = '',
  style = {},
  info = '',
  name = '',
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
  placeholder = '',
  defaultValue = '',
}) {
  const [showError, setShowError] = useState<boolean>();
  const [ref] = useState<React.RefObject<HTMLInputElement>>(refElement);
  let timeout;
  useEffect(() => {
    if (hasError) {
      timeout = setTimeout(() => {
        setShowError(true);
      }, 500);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [hasError]);

  useEffect(() => {
    if (ref?.current) {
      ref.current.value = defaultValue;
    }
  }, [defaultValue]);

  const renderError = () => (
    !info && hasError &&
      <div className={`${styles.error} ${showError ? '' : 'invisible'}`}>
        <i className={`ic icon-info ${styles.errorIcon}`}/>
        {hasError}
      </div>
  );

  return (
       <div className={`${styles.container}`} style={style}>
           <div className={`${styles.label}`} style={labelStyle}>{label}</div>
           <input
            name={name}
            style={inputStyle}
            className={`${styles.input} ${hasError && showError ? styles.inputError : ''}`}
            onClick={onClick}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
            type={type}
            placeholder={placeholder}
          />
            {info && <div className={styles.info}>{info}</div>}
            {renderError()}
       </div>
  );
}

export default InputField;
